/** Публичные и защищённые URL раздела портала (единый префикс `/portal`). */
/** Публичный реестр цифрового депонирования (без авторизации). */
export const PUBLIC_DEPOSITS = "/deposits"

export const PORTAL_INDEX = "/portal"
export const PORTAL_EVENTS = "/portal/events"
/** Каталог всех мероприятий (вкладка «Все»). */
export const PORTAL_EVENTS_ALL = "/portal/events/all"
export const PORTAL_EVENTS_CREATED = "/portal/events/created"
export const PORTAL_EVENTS_MODERATION = "/portal/events/moderation"
export const PORTAL_EVENTS_REGISTRATIONS = "/portal/events/registrations"
export const PORTAL_EVENTS_ATTENDANCE = "/portal/events/attendance"

/** Предпросмотр созданного мероприятия (организатор). */
export const portalEventPreviewPath = (eventId: string) =>
  `/portal/events/preview/${encodeURIComponent(eventId)}`

/** Просмотр профиля участника (инициатор / модератор заявок). */
export const portalEventParticipantProfilePath = (eventId: string, userId: string) =>
  `/portal/events/preview/${encodeURIComponent(eventId)}/participant/${encodeURIComponent(userId)}`

/** Публичная карточка мероприятия (без кабинета и бокового меню). */
export const publicEventDetailPath = (eventId: string) =>
  `/events/${encodeURIComponent(eventId)}`

/** Карточка мероприятия в кабинете (с боковым меню). */
export const portalEventDetailPath = (eventId: string) =>
  `/portal/events/${encodeURIComponent(eventId)}`

export const PORTAL_PROJECTS = "/portal/projects"
export const PORTAL_PROJECTS_REGISTRY = "/portal/projects/registry"
export const PORTAL_PROJECTS_MY = "/portal/projects/my"
export const PORTAL_PROJECTS_APPLY = "/portal/projects/apply"
export const PORTAL_PROJECTS_MODERATION = "/portal/projects/moderation"
export const PORTAL_PROJECTS_EVALUATION = "/portal/projects/evaluation"
export const PORTAL_PROJECTS_CRITERIA = "/portal/projects/criteria"
export const PORTAL_PROJECTS_SCOREBOARD = "/portal/projects/scoreboard"
export const PORTAL_PROJECTS_EVALUATION_SUMMARY_EXPERTS = "/portal/projects/evaluation-summary/experts"
export const PORTAL_PROJECTS_EVALUATION_SUMMARY_PROJECTS = "/portal/projects/evaluation-summary/projects"
export const PORTAL_PROJECTS_TEAM_INVITATIONS = "/portal/projects/team-invitations"
export const PORTAL_PROJECTS_TEAM = "/portal/projects/team"

/** Deep link: управление командой проекта. */
export const portalProjectsTeamPath = (projectId: string) =>
  `${PORTAL_PROJECTS_TEAM}?${new URLSearchParams({ projectId }).toString()}`

/** Deep link: страница приглашений в команду (query для TeamInvitationsPanel). */
export const portalProjectsTeamInvitationPath = (
  projectId: string,
  memberId: string,
  projectTitle?: string | null,
) => {
  const q = new URLSearchParams()
  q.set("projectId", projectId)
  q.set("memberId", memberId)
  const title = projectTitle?.trim()
  if (title) q.set("projectTitle", title)
  return `${PORTAL_PROJECTS_TEAM_INVITATIONS}?${q.toString()}`
}

/** Кабинет: карточка проекта по id. */
export const portalProjectDetailPath = (projectId: string) =>
  `/portal/projects/${encodeURIComponent(projectId)}`
export const PORTAL_DEPOSIT = "/portal/deposit"
/** Кабинет: публичный реестр (тот же каталог, что и `PUBLIC_DEPOSITS`). */
export const PORTAL_DEPOSIT_REGISTRY = "/portal/deposit/registry"
/** Кабинет: карточка записи из публичного реестра депонирования. */
export const portalDepositRegistryDetailPath = (depositId: string) =>
  `/portal/deposit/registry/${encodeURIComponent(depositId)}`
/** Кабинет: «Мои депонирования». */
export const PORTAL_DEPOSIT_MY = "/portal/deposit/my"
/** Кабинет: новая заявка (редирект на черновик с id). */
export const PORTAL_DEPOSIT_APPLY = "/portal/deposit/apply"
/** Кабинет: конструктор заявки по id черновика. */
export const portalDepositApplyPath = (depositId: string) =>
  `/portal/deposit/apply/${encodeURIComponent(depositId)}`
/** Кабинет: детальная карточка моего депонирования. */
export const portalDepositMyDetailPath = (depositId: string) =>
  `/portal/deposit/my/${encodeURIComponent(depositId)}`
/** Кабинет: модерация (только с политикой Approve). */
export const PORTAL_DEPOSIT_MODERATION = "/portal/deposit/moderation"
/** Кабинет: детальная карточка заявки для модератора. */
export const portalDepositModerationDetailPath = (depositId: string) =>
  `/portal/deposit/moderation/${encodeURIComponent(depositId)}`
export const PORTAL_ADMIN = "/portal/admin"
